/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { Auth } from '@stores/auth/auth';
import { LinkedAccounts } from '@stores/linkedAccounts/linkedAccounts';
import { Loading } from '@stores/loading/loading';
import { Notifications } from '@stores/notifications/notifications';
import { Social } from '@stores/social/social';
import { Users } from '@stores/users/users';

export class Store {
  auth: Auth;
  loading: Loading;
  linkedAccounts: LinkedAccounts;
  notifications: Notifications;
  social: Social;
  users: Users;

  constructor() {
    this.loading = new Loading();
    this.notifications = new Notifications();

    this.auth = new Auth(this.loading, this.notifications);
    this.linkedAccounts = new LinkedAccounts(this.auth, this.loading, this.notifications);
    this.social = new Social(this.auth, this.loading, this.notifications);
    this.users = new Users(this.auth, this.loading, this.notifications);
  }
}
